import { Component, NgZone } from "@angular/core";
import { NavController, NavParams, ModalController } from "ionic-angular";

import { AddOrderServiceProvider } from "./../add-order.service";

import { APIServiceProvider } from "./../../../common/services/api.service";
import { HelperServiceProvider } from "./../../../common/services/helper.service";

import { AddressModalPage } from "../../../modals/address/address.modal";

import { MissingAddressModalPage } from "../../../modals/missingaddress/missingaddress.modal";

@Component({
	selector: "page-address",
	templateUrl: "address.html"
})
export class AddressPage {
	constructor(
		public navCtrl: NavController,
		public helperService: HelperServiceProvider,
		public navParams: NavParams,
		public zone: NgZone,
		public addOrderService: AddOrderServiceProvider,
		public modalController: ModalController,
		public apiService: APIServiceProvider
	) {}

	selectedAddress: any = {};
	public mulitpleAddress = false;
	saveCustomerBtn = false;
	public all_district = [];
	public all_tehsil = [];
	public all_village = [];
	public all_pincode = [];
	public searchedPincode = null;

	ionViewDidLoad() {
		console.log("ionViewDidLoad AddressPage");
	}

	addMissingAddress() {
		let modalObject: any = {};
		modalObject = this.modalController.create(MissingAddressModalPage);
		modalObject.present();
	}

	removeAddressPart(type) {
		if (type === "state") {
			this.addOrderService.postData.state = null;
			this.addOrderService.postData.district = null;
			this.addOrderService.postData.tehsil = null;
			this.addOrderService.postData.village = null;
			this.addOrderService.postData.pincode = null;
		}

		if (type === "district") {
			this.addOrderService.postData.district = null;
			this.addOrderService.postData.tehsil = null;
			this.addOrderService.postData.village = null;
			this.addOrderService.postData.pincode = null;
		}

		if (type === "tehsil") {
			this.addOrderService.postData.tehsil = null;
			this.addOrderService.postData.village = null;
			this.addOrderService.postData.pincode = null;
		}

		if (type === "village") {
			this.addOrderService.postData.village = null;
			this.addOrderService.postData.pincode = null;
		}

		this.addOrderService.is_multiple_pincode = false;
		this.addOrderService.is_multiple_address = false;
		this.addOrderService.masterAddressId = null;
		this.addOrderService.newmissingAddress = false;
	}

	openAddressModal(type_address) {
		let modalObject: any = {};

		if (
			type_address === "district" &&
			!this.addOrderService.postData.state
		) {
			return false;
		}

		if (
			type_address === "tehsil" &&
			(!this.addOrderService.postData.state ||
				!this.addOrderService.postData.district)
		) {
			return false;
		}

		if (
			type_address === "village" &&
			(!this.addOrderService.postData.state ||
				!this.addOrderService.postData.district ||
				!this.addOrderService.postData.tehsil)
		) {
			return false;
		}

		if (
			type_address === "pincode" &&
			(!this.addOrderService.postData.state ||
				!this.addOrderService.postData.district ||
				!this.addOrderService.postData.tehsil ||
				!this.addOrderService.postData.tehsil)
		) {
			return false;
		}

		modalObject = this.modalController.create(AddressModalPage, {
			type: type_address
		});

		modalObject.present();
	}

	continueCustomerAddress() {
		if (
			this.addOrderService.postData.state !== null &&
			this.addOrderService.postData.district != null &&
			this.addOrderService.postData.tehsil !== null &&
			this.addOrderService.postData.village !== null
		) {
			this.saveCustomerBtn = true;

			const postData: any = {
				customer_id: this.addOrderService.postData.customer_id,
				mobile_no: this.addOrderService.postData.mobile_no,
				mobile: this.addOrderService.postData.mobile_no,
				state: this.addOrderService.postData.state.toUpperCase(),
				district: this.addOrderService.postData.district.toUpperCase(),
				tehsil: this.addOrderService.postData.tehsil.toUpperCase(),
				village: this.addOrderService.postData.village.toUpperCase(),
				pincode: this.addOrderService.postData.pincode,
				address_line_1: this.addOrderService.postData.address_line_1
			};

			if (this.addOrderService.masterAddressId) {
				postData.master_address_id = this.addOrderService.masterAddressId;
			}

			this.apiService
				.post("customer/save-customer-address", postData)
				.subscribe(result => {
					this.saveCustomerBtn = false;
					this.navCtrl.parent.select(2);
					this.addOrderService.masterAddressId = null;
				});
		} else {
			this.saveCustomerBtn = false;
			this.helperService.presentToast(
				"State , District , Tehsil or Village cannot be empty"
			);
		}
	}

	getAddressByPincode() {
		this.mulitpleAddress = false;
		this.addOrderService.is_multiple_address = false;
		this.addOrderService.is_multiple_pincode = false;

		this.selectedAddress = {
			state: null,
			district: null,
			tehsil: null,
			village: null,
			pincode: null
		};

		if (
			this.searchedPincode &&
			this.searchedPincode.toString().length === 6
		) {
			this.addOrderService.all_district = [];
			this.addOrderService.all_tehsil = [];
			this.addOrderService.all_village = [];
			this.addOrderService.all_pincode = [];
			const districts = [];
			const tehsils = [];
			const villages = [];
			const states = [];
			const pincodes = [];

			var apiUrl = "customer/address/location/" + this.searchedPincode;

			this.apiService.get(apiUrl).subscribe(response => {
				this.removeAddress();

				if (response["data"].length > 1) {
					this.addOrderService.is_multiple_address = true;
				} else {
					this.addOrderService.is_multiple_address = false;
				}

				if (response["data"]) {
					const address_list = response["data"];
					address_list.forEach(item => {
						if (states.indexOf(item.state_name) === -1) {
							states.push(item.state_name);
						}
						if (districts.indexOf(item.district_name) === -1) {
							districts.push(item.district_name);
						}
						if (tehsils.indexOf(item.tehsil_name) === -1) {
							tehsils.push(item.tehsil_name);
						}
						if (villages.indexOf(item.village_name) === -1) {
							villages.push(item.village_name);
						}
						if (
							item.pincode !== null &&
							pincodes.indexOf(item.pincode) === -1
						) {
							pincodes.push(item.pincode);
						}
					});

					if (states.length === 1) {
						this.addOrderService.postData.state = states[0];

						this.getAddress(
							"state",
							this.addOrderService.postData.state
						);
					}

					if (districts.length === 1) {
						this.addOrderService.postData.district = districts[0];

						this.getAddress(
							"district",
							this.addOrderService.postData.district
						);
					}

					if (tehsils.length === 1) {
						this.addOrderService.postData.tehsil = tehsils[0];

						this.getAddress(
							"tehsil",
							this.addOrderService.postData.tehsil
						);
					}

					if (villages.length === 1) {
						this.addOrderService.postData.village = villages[0];

						this.getAddress(
							"village",
							this.addOrderService.postData.village
						);
					}

					if (pincodes.length === 1 && villages.length === 1) {
						this.addOrderService.postData.pincode = pincodes[0];
					}

					if (villages.length === 1 && pincodes.length === 1) {
						this.mulitpleAddress = false;
					} else if (address_list.length > 0) {
						this.mulitpleAddress = true;
					}
				}
			});
		}
	}

	getAddress(type_address, value) {
		this.addOrderService.postData[type_address] = value;

		if (type_address === "pincode") {
			return false;
		}

		let addressInfo: any = {};

		addressInfo.state_name = value;

		if (type_address === "state") {
			addressInfo.state_name = value;
			addressInfo.searchon = "district_name";

			this.addOrderService.postData.district = null;
			this.addOrderService.postData.tehsil = null;
			this.addOrderService.postData.village = null;
			this.addOrderService.postData.pincode = null;
		}

		if (type_address === "district") {
			addressInfo.state_name = this.addOrderService.postData.state;
			addressInfo.district_name = this.addOrderService.postData.district;

			this.addOrderService.postData.tehsil = null;
			this.addOrderService.postData.village = null;
			this.addOrderService.postData.pincode = null;

			addressInfo.searchon = "tehsil_name";
		}

		if (type_address === "tehsil") {
			addressInfo.state_name = this.addOrderService.postData.state;
			addressInfo.district_name = this.addOrderService.postData.district;
			addressInfo.tehsil_name = this.addOrderService.postData.tehsil;

			this.addOrderService.postData.village = null;
			this.addOrderService.postData.pincode = null;

			addressInfo.searchon = "village_name";
		}

		if (type_address === "village") {
			addressInfo.state_name = this.addOrderService.postData.state;
			addressInfo.district_name = this.addOrderService.postData.district;
			addressInfo.tehsil_name = this.addOrderService.postData.tehsil;
			addressInfo.village_name = this.addOrderService.postData.village;

			this.addOrderService.postData.pincode = null;

			addressInfo.searchon = "pincode";
		}

		this.apiService
			.post("customer/address/info", addressInfo)
			.subscribe(response => {
				var result = response["data"];

				var dataLength = result.length;

				this.addOrderService.is_multiple_pincode = false;

				if (type_address === "state") {
					this.addOrderService.all_district = [];
					this.addOrderService.all_district = result;
				}

				if (type_address === "district") {
					this.addOrderService.all_tehsil = [];
					this.addOrderService.all_tehsil = result;
				}

				if (type_address === "tehsil") {
					this.addOrderService.all_village = [];
					this.addOrderService.all_village = result;
				}

				if (type_address === "village") {
					if (dataLength === 1) {
						this.addOrderService.postData.pincode = result[0];
					}

					if (dataLength > 1) {
						this.addOrderService.is_multiple_pincode = true;
						this.addOrderService.all_pincode = [];
						this.addOrderService.all_pincode = result;
					} else {
						this.addOrderService.is_multiple_pincode = false;
						this.addOrderService.all_pincode = [];
					}
				}
			});
	}

	removeAddress() {
		this.addOrderService.postData.state = null;
		this.addOrderService.postData.district = null;
		this.addOrderService.postData.tehsil = null;
		this.addOrderService.postData.village = null;
		this.addOrderService.postData.pincode = null;
	}
}



// WEBPACK FOOTER //
// ./src/pages/addorder/address/address.ts